import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

/**
 * Sidebar del Centro Guida.
 *
 * Props:
 *  - chapters: capitoli filtrati (dal backend)
 *  - expanded: { [chapterId]: bool }
 *  - onToggleChapter(chapterId)
 *  - onSelectChapter(chapterId) -> scroll al capitolo
 *  - onSelectArticle(chapterId, articleId) -> scroll all'articolo
 *  - activeChapterId?, activeArticleId?
 */
export function GuideSidebar({
  chapters,
  expanded,
  onToggleChapter,
  onSelectChapter,
  onSelectArticle,
  activeChapterId,
  activeArticleId,
}) {
  return (
    <aside className="lg:sticky lg:top-4 lg:self-start" data-testid="guide-toc">
      <nav className="rounded-lg border border-suite-neutral-200 bg-white p-3">
        <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.14em] text-suite-neutral-500">
          Indice
        </div>
        <ul className="space-y-0.5 text-xs">
          {chapters.map((ch, i) => {
            const isOpen = !!expanded[ch.id];
            const isActive = activeChapterId === ch.id;
            return (
              <li key={ch.id}>
                <div className="flex items-start gap-1">
                  <button
                    type="button"
                    onClick={() => onToggleChapter?.(ch.id)}
                    className="mt-0.5 text-suite-neutral-400 hover:text-suite-primary"
                    aria-label={isOpen ? "Chiudi capitolo" : "Apri capitolo"}
                    data-testid={`guide-toc-toggle-${ch.id}`}
                  >
                    {isOpen ? <ChevronDown size={13} /> : <ChevronRight size={13} />}
                  </button>
                  <button
                    type="button"
                    className={`w-full text-left ${
                      isActive
                        ? "font-semibold text-suite-primary"
                        : "text-suite-neutral-700 hover:text-suite-primary"
                    }`}
                    onClick={() => onSelectChapter?.(ch.id)}
                    data-testid={`guide-toc-${ch.id}`}
                  >
                    <span className="text-suite-neutral-400">{i + 1}.</span>{" "}
                    {ch.title}
                  </button>
                </div>
                {isOpen && ch.articles?.length > 0 && (
                  <ul className="ml-4 mt-1 space-y-0.5 border-l border-suite-neutral-200 pl-3">
                    {ch.articles.map((a, j) => (
                      <li key={a.id}>
                        <button
                          type="button"
                          className={`w-full text-left text-[11px] leading-relaxed ${
                            activeArticleId === a.id
                              ? "font-semibold text-suite-primary"
                              : "text-suite-neutral-600 hover:text-suite-primary"
                          }`}
                          onClick={() => onSelectArticle?.(ch.id, a.id)}
                          data-testid={`guide-toc-article-${a.id}`}
                        >
                          <span className="text-suite-neutral-400">
                            {i + 1}.{j + 1}
                          </span>{" "}
                          {a.title}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
          {chapters.length === 0 && (
            <li className="italic text-suite-neutral-400">
              Nessun contenuto disponibile per il tuo ruolo.
            </li>
          )}
        </ul>
      </nav>
    </aside>
  );
}
